import BpmOsgpoModule from '@/helpers/Modules/Product/BpmOsgpoModule'

export function useBpmDraft ({
  policy,
  store,
  mode,
  route,
  router,
  notify,
  sharedApi,
  loaded,
  globalLoader,
  treatyStartDate,
}) {
  function handleDraftIsDrive (draftPolicy) {
    if (!draftPolicy?.isDrive || !draftPolicy.insurer || !Array.isArray(draftPolicy.insureds)) {
      return
    }
    const insuredIndex = draftPolicy.insureds.findIndex(insured => sharedApi.isSameClient(insured, draftPolicy.insurer))
    if (insuredIndex === -1) {
      return
    }
    draftPolicy.insureds.splice(insuredIndex, 1)
    if (Array.isArray(draftPolicy.clientAddedList)) {
      const identity = sharedApi.getClientIdentity(draftPolicy.insurer)
      const addedIndex = identity ? draftPolicy.clientAddedList.indexOf(identity) : -1
      if (addedIndex !== -1) {
        draftPolicy.clientAddedList.splice(addedIndex, 1)
      }
    }
  }

  function setPolicyNumber (draftId) {
    if (/^\d+$/.test(draftId)) {
      policy.number = parseInt(draftId)
    } else if (draftId) {
      policy.number = draftId
    }
  }

  function processDraftBusinessProcesses () {
    if (!policy || !Array.isArray(policy.business_process)) {
      return
    }

    policy.insurer = null
    policy.insureds = []
    policy.vehicle = []

    const now = new Date()
    const maxProcessAgeMs = 3 * 24 * 60 * 60 * 1000

    policy.business_process = policy.business_process.filter(item => [1, 2, 3, 5].includes(item.type))

    policy.business_process.filter(item => [1, 2, 3].includes(item.type)).forEach(process => {
      const updatedAt = process.updated_at ? new Date(process.updated_at) : null

      if (!updatedAt || isNaN(updatedAt.getTime())) {
        sharedApi.restartProcess(process.id)
        return
      }

      const diffMs = now.getTime() - updatedAt.getTime()

      if (diffMs > maxProcessAgeMs) {
        sharedApi.restartProcess(process.id)
      } else {
        if (BpmOsgpoModule.BusinessProcess.isCompleted(process)) {
          sharedApi.completeProcess(process.id)
          return
        }
      }
    })

    policy.business_process.filter(item => [5].includes(item.type)).forEach(process => {
      if (process.type === 5 && process.process_data) {
        globalLoader.value = true
        sharedApi.checkProcess(process.id)
      }
    })
  }

  function processDraftData (data) {
    loaded.value = true
    if ('result' in data && !data.result) {
      notify.error(data)
      router.replace({ query: {} })
    } else {
      if (data.policy && data.policy.product === BpmOsgpoModule.PRODUCT) {
        handleDraftIsDrive(data.policy)
        sharedApi.replacePolicy(data.policy)
        policy.wizardStep = BpmOsgpoModule.Validator.normalizeWizardStep(policy.wizardStep, policy)
        setPolicyNumber(route.query.draft)
        processDraftBusinessProcesses()
      } else {
        notify.error({ message: 'Черновик не найден' })
      }
    }
    loaded.value = false
  }

  function loadDraft () {
    loaded.value = true
    store.dispatch('bpmResetWizard', { treatyDate: treatyStartDate.value })
    return store.dispatch('bpmLoadDraft', { draftId: route.query.draft })
      .then(res => {
        processDraftData(res)
      })
      .catch(err => {
        notify.error(err)
      })
      .finally(() => {
        initializeAfterDraft()
      })
  }

  function initializeAfterDraft () {
    policy.treaty.date = treatyStartDate.value
    sharedApi.applyModeTreatySettings()
    loaded.value = false
    sharedApi.getManagers()
  }

  function saveDraft () {
    store.dispatch('bpmSaveDraft', {
      mode: mode.value,
      route,
      notify,
    })
  }

  return {
    loadDraft,
    saveDraft,
    processDraftData,
    processDraftBusinessProcesses,
    setPolicyNumber,
    initializeAfterDraft,
    handleDraftIsDrive,
  }
}
